import { render } from "./tab-master-blueprint.vue?vue&type=template&id=5d4e31b7&scoped=true"
import script from "./tab-master-blueprint.vue?vue&type=script&lang=js"
export * from "./tab-master-blueprint.vue?vue&type=script&lang=js"

import "./tab-master-blueprint.vue?vue&type=style&index=0&id=5d4e31b7&scoped=true&lang=css"

import exportComponent from "/home/gitlab-runner/builds/WwEazHb5/0/pln-pusdiklat/ups/assessment_hc_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d4e31b7"]])

export default __exports__